import { useCallback, useEffect, useMemo, useRef } from "react";
import { Tabs, Tab, Spinner } from "grommet";
import { BoxWindow } from "../components/BoxWindow";
import { useDispatch, useSelector } from "react-redux";
import { addNewDonate } from "../slices/donatesSlice";
import { Settings } from "../components/auc-settings/Settings";
import { useTranslation } from "react-i18next";
import { WheelAbout } from "../components/wheel-about/WheelAbout";
import { useGetCurrentUserQuery } from "../api/userApi";
import { authenticationSelector } from "../slices/authSlice";
import { connectSocket } from "../slices/socketReducer";
import { AuctionViewTab } from "../components/auction/AuctionViewTab";
import { WheelViewTab } from "../components/wheel/WheelViewTab";
import { formattedPriceNumber } from "../utils/priceUtils";
import { addLotWithMode } from "../slices/auctionDataSlice";
import { useNavigate, useParams } from "react-router-dom";

export const AuctionPage = () => {

	const { t, ready } = useTranslation(["lots-table", "wheel"], {
		useSuspense: false,
	});

	const { tab } = useParams();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isAuthenticated = useSelector(authenticationSelector);
	const { isSuccess: isCurrentUserSuccess } = useGetCurrentUserQuery(
		undefined,
		{ skip: !isAuthenticated }
	);
	const ws = useSelector((state) => state.ws.clients["donates"]);
	const connected = useSelector((state) => state.ws.connected["donates"]);
	const wsRef = useRef(ws);
    const connectedRef = useRef(connected);

	useEffect(() => {
        wsRef.current = ws;
        connectedRef.current = connected;
    }, [ws, connected]);

	const topicCallback = useCallback(async (messageOutput) => {
		const body = JSON.parse(messageOutput?.body);

		console.log(body);
		

		const addMode = body.addMode;
		const appendUsername = body.appendUsername;

		const donate = {
			id: body.id,
			donate: body.data.type === 'AUCTION_DONATE',
			sender: body.data.sender,
			message: body.data.message,
			currencyAmount: body.currencyAmount,
			appendUsername: body.appendUsername
		};

		if (addMode > 0) {
			const result = await dispatch(addLotWithMode({ lotName: `${donate.message}${appendUsername ? ` (${donate.sender})` : ''}`, cost: formattedPriceNumber(donate.currencyAmount), addMode: addMode })).unwrap();
			
			if (result) {
				if (wsRef.current !== undefined && connectedRef.current !== undefined && connectedRef.current) {
					wsRef.current.publish({ destination: '/app/donates/remove', body: JSON.stringify({ id: donate.id }) });
				}
			} else {
				dispatch(addNewDonate(donate));
			}
		} else {
			dispatch(addNewDonate(donate));
		}
	}, []);

	const wsTopics = [
		{
			path: `/user/queue/donates`,
			callback: topicCallback,
		},
	];

	useEffect(() => {
		if (isAuthenticated && isCurrentUserSuccess) {
			if (!ws && !connected) {
				dispatch(
					connectSocket(
						"donates",
						`${process.env.REACT_APP_WEBSOCKET_URL}/donates`,
						wsTopics
					)
				);
			}
			if (ws && !connected) {
				console.log("CONNECTING...");
				ws.activate();
			}
		}
		// return () => (ws && connected ? ws.deactivate() : null);
	}, [ws, isAuthenticated, isCurrentUserSuccess]);

	const activeIndex = useMemo(() => {
		switch (tab) {
			case 'lots':
				return 0;
			case 'wheel':
				return 1;
			case 'settings':
				return 2;
			case 'about':
				return 3;
			default:
				return 0;
		}
	}, [tab]);

	// 3. Handle Tab switching
	const onActive = (nextIndex) => {
		let tab = 'lots';
		if (nextIndex === 0) {
			tab = 'lots';
		} else if (nextIndex === 1) {
			tab = 'wheel';
		} else if (nextIndex === 2) {
			tab = 'settings';
		} else if (nextIndex === 3) {
			tab = 'about';
		}
		navigate(`/auction/${tab}`);
	};

	if (!ready) {
		return <Spinner />;
	}

	if (ready) {
		return (
			<>
				<Tabs activeIndex={activeIndex} onActive={onActive} alignControls="center" flex="grow">
					<Tab title={t("tab1")}>
						<BoxWindow>
							<AuctionViewTab />
						</BoxWindow>
					</Tab>
					<Tab title={t("tab2")}>
						<BoxWindow>
							<WheelViewTab />
						</BoxWindow>
					</Tab>
					<Tab title={t("tab3")}>
						<BoxWindow>
							<Settings />
						</BoxWindow>
					</Tab>
					<Tab title={t("tab4")}>
						<BoxWindow>
							<WheelAbout />
						</BoxWindow>
					</Tab>
					{/* <Tab title={t('tab5')} disabled>
                
              </Tab>
              <Tab title={t('tab6')} disabled>
                
              </Tab> */}
				</Tabs>
			</>
		);
	}
};
